import { BASE_URL } from 'app/i-was-here/constants';
const routes = {
  [BASE_URL]: {
    fetch: () =>
      import(
        /* webpackChunkName: 'i-was-here-route' */
        'app/i-was-here/asyncRoute'
      ).then(module => module.default),
  },
};
export default routes;
